import { css } from 'lit';
export default css `
    :host {
        display: block;
    }

    .container {
        display: grid;
        gap: var(--spacing-l);
        margin: 0 auto;
        max-width: var(--max-width);
    }

    .header {
        margin-block-start: var(--spacing-s);
    }

    .footer {
        display: flex;
        gap: var(--spacing-m);
    }

    @media screen and (min-width: 768px) {
        .header {
            grid-column-end: span 2;
        }
    }
`;
